import React from "react";
import { useTranslation } from "react-i18next";

// comp
import WrongPage from "Components/WrongPage";
import StyledSignText from "Components/WrongPage/SignText";

export default () => {
  return <WrongPage imgUrl={`images/certification.png`} SignText={SignText} />;
};

const SignText = () => {
  const { t } = useTranslation();
  return (
    <StyledSignText>
      <div>{t("authFail")}</div>
      <div className="smallText">{t("goWrong")}</div>
    </StyledSignText>
  );
};
